// extracted by mini-css-extract-plugin
module.exports = {"container":"TheFirst_container__14NOe","textBlock":"TheFirst_textBlock__G8MA9","button":"TheFirst_button__2Xvyq"};